module.exports = __webpack_public_path__ + "3c1ae8db2f20c336b5f69b21c39677c4.svg";